




























import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class EditorSection extends Vue {
  @Prop() private title!: string;
  @Prop({ default: true, type: Boolean }) private showAddIcon!: boolean;
  @Prop({ default: false, type: Boolean }) private isForm!: boolean;
}
